import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Modal } from '../modal';

@Component({
  selector: 'app-alert-modal',
  templateUrl: './alert-modal.component.html',
  styleUrls: ['./alert-modal.component.scss'],
})
export class AlertModalComponent extends Modal {

  constructor(
    modalCtrl: ModalController
  ) {
    super(modalCtrl);
  }

}
